<template>
  <div>
    <download-excel
    class   = "btn btn-default"
    :fetch   = "fetchData"
    :fields = "json_fields"
    worksheet = "Stock"
    :name    = "nameFile"
    :before-generate = "startDownload"
    :before-finish = "finishDownload"
    >
    <b-button >
        <b-spinner v-if="loading"  small/>
        &nbsp;Descargar
    </b-button>
    </download-excel>
  </div>
</template>

<script>

import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import moment from 'moment';
Vue.component('downloadExcel', JsonExcel)

export default {
    name: "DownloadExcelComponent",
    props: {
      headings: {
        type: Object,
        default: {}
      },
      url: {
        type: String,
        default: ""
      },
    },
    components: {
    },
    data() {
      return {
        loading: false,
        json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
      }
    },
     computed:{
      nameFile(){
        return "stock " + moment(Date.now()).format('YYYYMMDD h:mm') + ".xls"
      },
      json_fields(){
          var obj={};
          for(let key in this.headings)
          {
           var keyNew = String(this.headings[key]);
           var newObj={
               [keyNew]:key
           }
            Object.assign(obj,newObj);
          } 
        return obj;
      },
    },
    methods: {
        async fetchData(){
            const response = await this.$axios.get(this.url);
            return response.data.results;
        },
        startDownload(){
          this.loading=true
        },
        finishDownload(){
            this.loading=false
        },
    },
    mounted(){
    }
   
  }
</script>